module.exports = "/assets/data/1a2de21f9983a7e2db46dfa1d17b9626-BS34.data.json";